module.exports = __webpack_public_path__ + "media/images/diy/menu_icon-a095e086164e35f55eb17031bcf76c6b.svg";